import React from 'react'

import TotalUsers from 'tabs/dashboard/components/TotalUsers'
import TotalChats from 'tabs/dashboard/components/TotalChats'
import TotalQueriedTopics from 'tabs/dashboard/components/TotalQueriedTopics'
import Supervision from 'tabs/dashboard/components/Supervision'

type DashboardRoute = {
  path: string
  name: string
  component: () => JSX.Element
}

export const dashboardRoutes: DashboardRoute[] = [
  {
    path: 'total-users',
    name: 'Total Users',
    component: () => React.createElement(TotalUsers),
  },
  {
    path: 'chats',
    name: 'Chats',
    component: () => React.createElement(TotalChats),
  },
  {
    path: 'top-queried-topics',
    name: 'Top Queried Topics',
    component: () => React.createElement(TotalQueriedTopics),
  },
  {
    path: 'supervision',
    name: 'Supervision',
    component: () => React.createElement(Supervision),
  },
]
